import { useContext } from "react";
import { ThemeContext, ThemeContextType } from "./ThemeContext";

export const useThemeSwitch = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeSwitch must be used within a ThemeProvider");
  }
  return context;
};
